import { __assign } from "tslib";
import { createIvrsApi, ivrsRelativePath } from './';
import { createFakePostResponder, createFakeGetResponder, createFakePutResponder, createFakeDeleteResponder } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
export var createIvrsApiTestKit = function (parentPath) {
    var fakeHttp = createHttpTestKit();
    var api = createIvrsApi(parentPath, fakeHttp);
    var url = parentPath + ivrsRelativePath;
    var testKit = {
        whenGetFlows: function () { return createFakeGetResponder(fakeHttp, "".concat(url)); },
        whenAddFlow: function (dto) { return createFakePostResponder(fakeHttp, "".concat(url))(dto); },
        whenUpdateFlow: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(url, "/").concat(dto.id))(dto.data);
        },
        whenDeleteFlow: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "".concat(url, "/").concat(dto.id));
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map